import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Form, Card, Spinner, Button } from 'react-bootstrap';
import { AuthContext } from '../../../auth/AuthContext';
import { useContextInfo } from '../../../context/ContextInfo';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
import { usosCFDI } from '../../../data/userSet';
import { checkAccess } from '../../../helpers/details';
const initialState = {
    id: '',
    id_user: '',
    emitir: false,
    razon: '',
    rfc: '',
    clave: '',
    codigo: '',
    sendemail: false,
    uso: 'G01',
    metodo: 'PUE',
};
const CardDtFactura = ({ activeTab, activo }) => {
    const { id } = useParams();
    let idR = atob(id);
    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Facturación', auth.accesos);
const {fact_editar_conf}=permisos.functions

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const { setResp } = useContextInfo();
    const { loading, data, getInfo } = useGetDta(`user/datafac/${idR}`);
    const { dtFac } = data;

    const [values, handleInputChange, setFormValue] = useForm(initialState);

    useEffect(() => {
        if (!dtFac) {
            setFormValue({ ...values, ...initialState });
        } else {
            setFormValue({ ...values, ...dtFac });
        }
    }, [data, dtFac, idR, activo, activeTab]);

    useEffect(() => {
        getInfo(`user/datafac/${idR}`);
    }, [idR, activeTab, activo]);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken('user/datafac', { ...values, id_user: idR }, 'POST');
            if (res.ok) setFormValue({ ...res.data });
            setResp(res);
        }
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <Card>
            <Card.Header>
                {' '}
                <i className="mdi mdi-data-matrix" /> Datos de Facturación
            </Card.Header>{' '}
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Row>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCustom0">
                                <Form.Label> Emitir Factura</Form.Label>
                                <Form.Select value={values.emitir} name="emitir" required onChange={handleInputChange}>
                                    <option value={true}>Activado</option>
                                    <option value={false}>Desactivado</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>{' '}
                        <Col>
                            <Form.Group className="mb-3" controlId="validationCustom999">
                                <Form.Label> RFC</Form.Label>
                                <Form.Control
                                    required={values.emitir === 'true'}
                                    type="text"
                                    value={values.rfc}
                                    name="rfc"
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                    </Row>{' '}
                    <Col>
                        <Form.Group className="mb-3" controlId="validationCustom999">
                            <Form.Label> Razón social</Form.Label>
                            <Form.Control
                                required={values.emitir === 'true'}
                                type="text"
                                value={values.razon}
                                name="razon"
                                onChange={handleInputChange}
                            />
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                    <Row>
                        <Col xl={6}>
                            <Form.Group className="mb-3" controlId="validationCustom999">
                                <Form.Label> Clave del régimen fiscal</Form.Label>
                                <Form.Control
                                    required={values.emitir === 'true'}
                                    type="text"
                                    value={values.clave}
                                    name="clave"
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                        <Col xl={6}>
                            <Form.Group className="mb-3" controlId="validationCustom999">
                                <Form.Label> Codigo postal</Form.Label>
                                <Form.Control
                                    required={values.emitir === 'true'}
                                    type="text"
                                    value={values.codigo}
                                    name="codigo"
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                    </Row>{' '}
                    <Col>
                        <Form.Group className="mb-3" controlId="validationCustom0">
                            <Form.Label>Uso CFDI</Form.Label>
                            <Form.Select value={values.uso} name="uso" required onChange={handleInputChange}>
                                {usosCFDI.map((us, i) => (
                                    <option key={i} value={us.clave}>
                                        {us.des}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>{' '}
                    <Row>
                        {' '}
                        <Col>
                            <Form.Group className="mb-3" controlId="validationCustom0">
                                <Form.Label>Forma de Pago</Form.Label>
                                <Form.Select value={values.metodo} name="metodo" required onChange={handleInputChange}>
                                    <option value="PUE">Pago en una solo exhibición</option>
                                    <option value="PPD">Pago en parcialidades o diferido</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>{' '}
                        <Col>
                            <Form.Group className="mb-3" controlId="validationCustomsend">
                                <Form.Label> Enviar correo</Form.Label>
                                <Form.Select
                                    value={values.sendemail}
                                    name="sendemail"
                                    required
                                    onChange={handleInputChange}>
                                    <option value={true}>Activado</option>
                                    <option value={false}>Desactivado</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    {load ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <>{fact_editar_conf && <Button type="submit">Guardar</Button>}</>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
};

export default CardDtFactura;
